import BaseValidator from 'ember-cp-validations/validators/base';
import isValidUrl from '@intercom/intersection-shared-models/helpers/url-validator';
const UrlWithTemplateString = BaseValidator.extend({
  validate(value, _options, model) {
    if (!model.insertable) {
      return true;
    }
    // remove template strings from url
    let url = (value || '').replace(/(\{{.*?\}}) */g, '_');
    return !!isValidUrl(url);
  }
});
UrlWithTemplateString.reopenClass({
  getDependentsFor() {
    return ['model.insertable'];
  }
});
export default UrlWithTemplateString;